export default __webpack_public_path__ + "static/media/show1.70063c84.jpeg";